export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'companies',
      displayName: 'menu.companies',
      meta: {
        icon: 'home_work',
      },
    },
    {
      name: 'firmwares',
      displayName: 'menu.firmwares',
      meta: {
        icon: 'upload_file',
      },
    },
    {
      name: 'kkt',
      displayName: 'menu.kkt',
      meta: {
        icon: 'developer_board',
      },
    },
    {
      name: 'licenses',
      displayName: 'menu.license',
      meta: {
        icon: 'domain_verification',
      },
    }
  ] as INavigationRoute[],
}
